import { Expert } from '../types/experts';

// This is a directory of prominent market analysts and experts in the field of forex, Gold (XAU), 
// and USD markets. These experts are NOT affiliated with XAUJournal.
export const experts: Expert[] = [
  // Independent Analysts
  {
    id: 'kathy-lien',
    name: 'Kathy Lien',
    role: 'Former Director of Currency Research at GFT',
    title: 'Former Director of Currency Research at GFT', // Keeping for backwards compatibility
    category: 'independent',
    shortBio: 'Author of multiple forex books with extensive experience in currency research.',
    bio: 'Kathy Lien is a globally recognized currency analyst, author, and educator. She has authored several bestselling books on forex trading and is known for her clear explanations of complex market dynamics. Her analysis frequently focuses on how economic data affects currency pairs, particularly involving the USD.',
    twitter: 'kathylienfx',
    expertise: ['Forex', 'Economic Indicators', 'Technical Analysis', 'USD'],
    website: 'https://www.kathylien.com'
  },
  {
    id: 'boris-schlossberg',
    name: 'Boris Schlossberg',
    role: 'Managing Director of FX Strategy at BK Asset Management',
    title: 'Managing Director of FX Strategy', // Keeping for backwards compatibility
    organization: 'BK Asset Management',
    category: 'independent',
    shortBio: 'Specialist in forex strategy with decades of experience in currency markets.',
    bio: 'Boris Schlossberg has over 20 years of experience in forex trading and is a leading strategist in currency markets. He specializes in analyzing market dynamics and technical patterns, with particular focus on day trading opportunities and economic impact on currency movements.',
    twitter: 'Fxflow',
    expertise: ['Forex', 'Day Trading', 'Market Sentiment', 'Risk Management'],
    website: 'https://www.bkassetmanagement.com'
  },
  {
    id: 'raoul-pal',
    name: 'Raoul Pal',
    role: 'Former Hedge Fund Manager, Founder of Real Vision',
    title: 'Former Hedge Fund Manager', // Keeping for backwards compatibility
    category: 'independent',
    shortBio: 'Founder of Real Vision and expert in macroeconomic analysis.',
    bio: 'Raoul Pal brings a macro perspective to markets, having worked at Goldman Sachs and managed funds. Through Real Vision, he provides insights on global markets including currencies, commodities, and economic trends. His analysis often encompasses both gold and USD in the context of broader economic cycles.',
    twitter: 'RaoulGMI',
    expertise: ['Macroeconomics', 'Gold', 'Global Markets', 'Economic Cycles'],
    website: 'https://www.realvision.com'
  },
  {
    id: 'peter-brandt',
    name: 'Peter Brandt',
    role: 'Classical Charting Expert, Veteran Trader',
    title: 'Classical Charting Expert', // Keeping for backwards compatibility
    category: 'independent',
    shortBio: 'Veteran trader with 40+ years of experience in technical analysis and classical charting.',
    bio: 'With over four decades of trading experience, Peter Brandt is renowned for his expertise in classical chart patterns and technical analysis. He has a particular interest in commodities markets, including gold, and frequently shares insights on long-term price patterns and market cycles.',
    twitter: 'PeterLBrandt',
    expertise: ['Technical Analysis', 'Classical Charting', 'Commodities', 'Gold'],
    website: 'https://www.peterlbrandt.com',
    publications: [
      {
        title: 'Diary of a Professional Commodity Trader',
        url: 'https://www.amazon.com/Diary-Professional-Commodity-Trader-Lessons/dp/0470521457'
      }
    ]
  },
  {
    id: 'john-kicklighter',
    name: 'John Kicklighter',
    role: 'Chief Strategist at DailyFX',
    title: 'Chief Strategist', // Keeping for backwards compatibility
    organization: 'DailyFX',
    category: 'independent',
    shortBio: 'Expert in market strategy with focus on fundamental and technical analysis.',
    bio: 'John Kicklighter specializes in combining fundamental and technical analysis to identify trading opportunities across multiple markets. His expertise includes forex, commodities, and understanding market volatility patterns.',
    twitter: 'JohnKicklighter',
    expertise: ['Forex', 'Volatility Analysis', 'Multi-market Correlations']
  },
  {
    id: 'marc-chandler',
    name: 'Marc Chandler',
    role: 'Managing Director at Bannockburn Global Forex',
    title: 'Managing Director', // Keeping for backwards compatibility
    organization: 'Bannockburn Global Forex',
    category: 'independent',
    shortBio: 'Respected analyst with decades of experience in global forex markets.',
    bio: 'Marc Chandler brings an institutional perspective to currency markets, having worked with major financial institutions before joining Bannockburn. His analysis often focuses on how political and economic policies impact currency valuations globally.',
    twitter: 'marcmakingsense',
    expertise: ['Policy Impact', 'Global Economics', 'Central Bank Analysis']
  },
  {
    id: 'ashraf-laidi',
    name: 'Ashraf Laidi',
    role: 'Founder of Intermarket Strategy Ltd',
    title: 'Founder', // Keeping for backwards compatibility
    organization: 'Intermarket Strategy Ltd',
    category: 'independent',
    shortBio: 'Specialist in intermarket analysis and currency correlations.',
    bio: 'Ashraf Laidi is known for his insights on how different markets influence each other, with particular expertise in how gold, oil, and equity markets impact currency movements. His intermarket approach offers a comprehensive view of global financial dynamics.',
    twitter: 'alaidi',
    expertise: ['Intermarket Analysis', 'Gold-Currency Correlations', 'Commodity Currencies']
  },

  // Institutional Analysts
  {
    id: 'masafumi-yamamoto',
    name: 'Masafumi Yamamoto',
    role: 'Chief FX Strategist at Mizuho Securities',
    title: 'Chief FX Strategist', // Keeping for backwards compatibility
    organization: 'Mizuho Securities',
    category: 'institutional',
    shortBio: 'Leading expert on Japanese yen and Asian currency markets.',
    bio: 'Masafumi Yamamoto specializes in Asian currency markets with a particular focus on the Japanese yen. His analysis incorporates Bank of Japan policy decisions and their impact on JPY pairs and regional economic trends.'
  },
  {
    id: 'valentin-marinov',
    name: 'Valentin Marinov',
    role: 'Head of G10 FX Strategy at Credit Agricole',
    title: 'Head of G10 FX Strategy', // Keeping for backwards compatibility
    organization: 'Credit Agricole',
    category: 'institutional',
    shortBio: 'Specialist in G10 currencies with focus on macroeconomic impacts.',
    bio: 'Valentin Marinov provides institutional analysis of major currency pairs, with expertise in how macroeconomic trends impact G10 currencies. His research covers interest rate differentials, central bank policies, and their effects on currency valuations.',
    twitter: 'valentinmrn',
    expertise: ['G10 Currencies', 'Central Bank Policy', 'Interest Rate Impact']
  },
  {
    id: 'kit-juckes',
    name: 'Kit Juckes',
    role: 'Chief FX Strategist at Societe Generale',
    title: 'Chief FX Strategist', // Keeping for backwards compatibility
    organization: 'Societe Generale',
    category: 'institutional',
    shortBio: 'Veteran analyst with expertise in global macro and currency markets.',
    bio: 'Kit Juckes brings decades of experience to his analysis of currency markets from an institutional perspective. He specializes in connecting macroeconomic trends to specific currency movements and frequently comments on gold as a safe-haven asset.',
    twitter: 'kitjuckes',
    expertise: ['Macroeconomics', 'Safe-Haven Assets', 'USD Trends']
  },
  {
    id: 'jane-foley',
    name: 'Jane Foley',
    role: 'Senior FX Strategist at Rabobank',
    title: 'Senior FX Strategist', // Keeping for backwards compatibility
    organization: 'Rabobank',
    category: 'institutional',
    shortBio: 'Renowned for analysis of European currencies and economic policy impacts.',
    bio: 'Jane Foley specializes in European currency markets with a focus on how ECB policies and regional economic data impact the euro. Her analysis often incorporates political developments and their influence on currency valuation.',
    twitter: 'JaneFootz',
    expertise: ['European Currencies', 'Central Bank Policy', 'Political Risk']
  },
  {
    id: 'george-saravelos',
    name: 'George Saravelos',
    role: 'Global Head of FX Research at Deutsche Bank',
    title: 'Global Head of FX Research', // Keeping for backwards compatibility
    organization: 'Deutsche Bank',
    category: 'institutional',
    shortBio: 'Leading research on currency markets with institutional perspective.',
    bio: 'George Saravelos provides institutional analysis of currency markets with a global perspective. His research focuses on major trends affecting currencies, including central bank policies, economic shifts, and global risk sentiment.',
    twitter: 'GeorgeSaravelos',
    expertise: ['Global Currency Trends', 'Institutional Analysis', 'Risk Sentiment']
  },
];